export const BORDER_RADIUS_PAPER = 15;
export const BORDER_RADIUS_BUTTON = 30;
export const BACKGROUND_TABLE_ROW_EVEN = '#D6E9FD';
export const TABLE_HEADER_HOVER_COLOR = '#77a0ff';
